export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Bell.4e7ba49f.svg","height":24,"width":21,"blurWidth":0,"blurHeight":0};